import { useState, useEffect } from 'react';
import { X, DownloadSimple } from '@phosphor-icons/react';
import { motion, AnimatePresence } from '@/lib/motion';
import { haptic } from '../utils/haptic';

export const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show after 30s if not dismissed before
      const dismissed = sessionStorage.getItem('pwa-dismissed');
      if (!dismissed) {
        setTimeout(() => setShow(true), 30000);
      }
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    haptic('success');
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      setShow(false);
    }
    setDeferredPrompt(null);
  };

  const dismiss = () => {
    haptic('light');
    setShow(false);
    sessionStorage.setItem('pwa-dismissed', '1');
  };

  return (
    <AnimatePresence>
      {show && deferredPrompt && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-20 left-4 right-4 z-[9998] md:hidden"
          data-testid="install-prompt"
        >
          <div className="bg-obsidian text-white p-4 shadow-2xl flex items-center gap-3">
            <DownloadSimple weight="bold" className="w-6 h-6 text-bronze flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-xs font-bold uppercase tracking-wider">Install App</p>
              <p className="text-[10px] text-white/50 mt-0.5">Add to home screen for the best experience</p>
            </div>
            <button type="button"
              onClick={install}
              className="px-4 py-2 bg-bronze text-obsidian text-[10px] font-bold uppercase tracking-wider flex-shrink-0"
              data-testid="install-btn"
            >
              Install
            </button>
            <button type="button" onClick={dismiss} className="p-1.5 hover:bg-white/10 flex-shrink-0">
              <X weight="bold" className="w-4 h-4 text-white/40" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
